import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { BodyEnvio4 } from 'src/app/interfaces/body-envio4';
import { BodyCargaPlanes } from 'src/app/interfaces/body_cargaPlanes';
import { DatosGeneralesModel } from 'src/app/new-flow/models/datosGenenrales';
import { PlanModels } from 'src/app/models/plan_models';
import { DataLayerService } from 'src/app/services/dataLeyer/data-leyer.service';
import { OrquestadorService } from 'src/app/services/orquestador/orquestador.service';
import { environment } from 'src/environments/environment';
import {
  TIEMPO_INACTIVO,
  DATOS_PROPIETARIO,
  RESUMEN_COMPRA,
  ERROR,
} from 'src/app/routes.constants';
import { SharedModule } from '@app/shared/shared.module';
import { GeneralDataService } from '@app/services/general/general-data.service';
import { Store } from '@ngrx/store';
import { selectDataByKey } from 'src/storage/general.selectors';
import { Observable, Subscription } from 'rxjs';
import { setData } from 'src/storage/general.actions';
import { LoaderService } from '@app/services/general/loader.service';


@Component({
  selector: 'app-new-armar-plan',
  templateUrl: './new-armar-plan.component.html',
  styleUrls: ['./new-armar-plan.component.scss'],
})
export class NewArmarPlanComponent implements OnInit {
  loaderService = inject(LoaderService);
  generatedBody: any;
  asesorCode: string = '';
  bitacoraId: string = '';

  tenant$: Observable<any>;
  leadId$: Observable<any>;
  bitacoraId$: Observable<any>;
  propiedad$: Observable<any>;
  plan$: Observable<any>;

  private subscriptions: Subscription = new Subscription();
  res: any;
  isClicked: boolean = false;
  isLoading: boolean = false;
  loaded: boolean = false;

  myForm: FormGroup = this.fb.group({});

  constructor(private cdr: ChangeDetectorRef,

    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private generalDataService: GeneralDataService,
    private orquestadorService: OrquestadorService,
    private store: Store,
  ) {

    this.tenant$ = this.store.select(selectDataByKey('Tenant'));
    this.leadId$ = this.store.select(selectDataByKey('leadId'));
    this.bitacoraId$ = this.store.select(selectDataByKey('bitacoraId'));
    this.propiedad$ = this.store.select(selectDataByKey('Property'));
    this.plan$ = this.store.select(selectDataByKey('Plan'));
  }

  optionalProducts = {
    PRD_CoveragePublicServices: this.myForm.get('2')?.value,
    PRD_CoverageAsistence: this.myForm.get('3')?.value,
  };

  ngOnInit(): void {

    this.loaderService.show(); // Mostrar el loader al iniciar la carga de datos
    this.loaderService.loading$.subscribe(({ loading, loaded }: { loading: boolean; loaded: boolean }) => {
      this.isLoading = loading;
      this.loaded = loaded;
    });

    this.myForm.valueChanges.subscribe(values => {
      const optionalProducts = {
        PRD_CoveragePublicServices: values[2] ? "true" : "false",
        PRD_CoverageAsistence: values[3] ? "true" : "false",
      };
      this.optionalProducts = optionalProducts;
    });

    this.subscriptions.add(
      this.plan$.subscribe(resume => {
        if (resume) {
          this.res = { ...resume };

          this.res.coverages.forEach((c: any) => {
            if (c.isOptional) {
              const controlName = c.order.toString();
              if (!this.myForm.contains(controlName)) {
                this.myForm.addControl(controlName, new FormControl(true));
              } else {
                this.myForm.get(controlName)?.setValue(true, { emitEvent: false });
              }
            }
          });
          this.cdr.markForCheck();
          this.cdr.detectChanges();
        }
      })
    );

    // Suscribirse al código de asesor
    this.subscriptions.add(
      this.store.select(selectDataByKey('codigoAsesor')).subscribe(code => {
        if (code) {
          console.log('Código de asesor desde el store:', code);
          this.asesorCode = code;
        }
      })
    );

    this.loaderService.hide();
  }

  getTotal(): number {
    if (!this.res) return 0;
    return this.res.coverages
      .reduce((sum: number, c: any) => {
        const isSelected = c.isOptional ? this.myForm.get(c.order.toString())?.value : true;
        return isSelected ? sum + c.price : sum;
      }, 0);
  }

  onCoverageChange() {
    this.cdr.detectChanges();
  }

  comprar() {
    this.isClicked = true;
    const optionalProducts = {
      PRD_CoveragePublicServices: this.myForm.get('3')?.value ? "true" : "false",
      PRD_CoverageAsistence: this.myForm.get('4')?.value ? "true" : "false",
    };

    this.store.dispatch(setData({
      key: 'optionalProducts',
      value: optionalProducts,
      merge: false
    }));

    const options = {
      keys: ['Tenant', 'Property', 'ProductCode'],
      screenPercentage: '25',
      leadId: 'leadId',
      asesorCode: this.asesorCode !== '' ? this.asesorCode : undefined,
      bitacoraId: this.bitacoraId !== '' ? this.bitacoraId : undefined
    };

    this.generalDataService.getbody(options).subscribe(body => {
      this.generatedBody = body;
      this.generatedBody = { ...body, optionalProducts };
    });

    window.scrollTo(0, 0);
    this.loaderService.show();

    this.orquestadorService.postOrquestador(this.generatedBody).subscribe(response => {
      if (response.error) {
        console.log('Error')
      } else {
        this.loaderService.hide();
        this.router.navigate(['seguros/hogar/arriendo/cotizador/datos-propietario'], { relativeTo: this.route.parent });
      }
    });

  }


}
